// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"61":"cbcffa33","106":"b06dc8a3","142":"9bd90544","249":"da9247fa","312":"8c22f699","467":"452b88fa","473":"0f5c669e","575":"19219f3d","617":"2156ae82","705":"97cf0abc","729":"9efa7f97"}[chunkId] + ".chunk.css";
};